<template>
  <div class="step-section-4" style="padding-top: 20px">
    <div
      style="
        width: 98%;
        height: 30px;
        line-height: 30px;
        margin-top: 260px;
        text-align: center;
        color: #409eff;
      "
    >
      <i class="el-icon-success" style="font-size: 30px"></i>
      信息提交成功，审核结果请留意您的联系手机短信或者参会入口界面查询
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StepSection4',
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/project/add-section/stepSection4.vue